module.exports = __webpack_public_path__ + "static/media/beselina.956aa865.png";